// IMPORT LIBS
import jQuery from 'jquery';
import noUiSlider from 'nouislider';
import { redirectPage } from './functions/redirectPage';


window.$ = jQuery;
window.jQuery = jQuery;
window.noUiSlider = noUiSlider;


// FUNCTION TO REDIRECT TO HOME PAGE
redirectPage();